import { render, staticRenderFns } from "./aboutHome.vue?vue&type=template&id=75b5f5b8&"
import script from "./aboutHome.vue?vue&type=script&lang=js&"
export * from "./aboutHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports